module.exports = __webpack_public_path__ + "static/media/displaygroup-thumbnail.6e8b93ea.jpg";